import React from "react";
import styled from "styled-components";

export const Header = styled.div`
  color: #6b778c;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.3333333333333333;
  padding: 24px 0px 0px 0px;
`;
export const ApplicationWidth = styled.div`
  width: 100%;
  margin: auto;
  margin-left: 10px;
`;
export const Flex = styled.div`
  display: flex;
`;
export const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  justifycontent: "space-between";
`;
export const IconRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
`;
export const Flex1 = styled.div`
  flex: 1;
  margin-right: 10px;
`;
export const Flex2 = styled.div`
  flex: 2;
`;
export const Flex3 = styled.div`
  flex: 3;
`;
export const Flex4 = styled.div`
  flex: 4;
`;
export const Flex5 = styled.div`
  flex: 5;
`;
export const greyed = { backgroundColor: "#F9F9FB", cursor: "pointer" };
export const transparent = { backgroundColor: "transparent" };
export const Selected = (props) => <div style={{ color: "#0052CC", fontWeight: "bold" }} {...props} />;
export const CONTENT_NAV_WIDTH = 240;
